import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withKeys as _withKeys, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76225786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cabecera text-caption mb-1" }
const _hoisted_2 = { class: "etiqueta" }
const _hoisted_3 = { class: "text-medium-emphasis text-center text-wrap" }
const _hoisted_4 = { class: "text-medium-emphasis text-right text-no-wrap" }
const _hoisted_5 = { class: "enfrentamiento" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 0,
  class: "marcador en-linea text-h6 text-center"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "text-center text-caption"
}
const _hoisted_10 = {
  key: 0,
  class: "text-medium-emphasis font-weight-bold text-no-wrap",
  title: "Puntos del sistema alemán"
}
const _hoisted_11 = ["onClick", "onKeydown"]
const _hoisted_12 = ["onClick", "onKeydown"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick", "onKeydown"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "validaciones mt-2" }
const _hoisted_20 = {
  key: 0,
  class: "text-center"
}
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-wrap align-center ga-1 mt-2"
}
const _hoisted_22 = { class: "d-flex ga-1 ms-auto" }

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { ActualizarPairingEquiposDTO, PartidaTorneoDTO } from "@/interfaces/Partidas";
import { UpdatePartidaTorneoDTO } from "@/interfaces/Live";
import { updatePairingTorneoAsync, updatePartidaTorneo } from "@/services/PartidaTorneoService";
import { getListaById, getListaPartidaAsync, getlistaTorneo } from "@/services/ListasService";
import { partidaJugada } from "@/utils/clasificacionLiga";
import { motivoSinLista, SIN_LISTA } from "@/utils/avisoLista";
import { mensajeDelBack } from "@/utils/mensajeDelBack";
import { useToast } from "@/composables/useToast";
import { useTorneoCerrado } from "@/composables/useTorneoCerrado";
import { useSistemaAleman } from "@/composables/useSistemaAleman";
import { calcularPuntosAleman } from "@/utils/sistemaAleman";
import ModalEditarPartidaGestion from "@/components/GestionTorneos/ModalEditarPartidaGestion.vue";
import ModalListaResultadoTorneo from "@/components/ResultadosTorneos/ModalListaResultadoTorneo.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalEditarPartida from "@/components/ResultadosTorneos/ModalEditarPartida.vue";
import ModalValidarPartida from "@/components/ResultadosTorneos/ModalValidarPartida.vue";
import ModalCambiarPairingEquipo from "@/components/PartidasTorneo/ModalCambiarPairingEquipo.vue";

// Una partida de cualquier evento (torneo individual, por equipos, por parejas, de más de una lista, liga o copa):
// resultado, general, ELO y listas. En la gestión el organizador mete el resultado o la valida; en lo que ve un
// jugador, le deja meter el suyo o validar el del rival cuando le toca

export default /*#__PURE__*/_defineComponent({
  __name: 'CardPartidaGestion',
  props: {
    partida: {},
    editable: { type: Boolean },
    etiqueta: {},
    pasa: {},
    listaPorPareja: { type: Boolean },
    idJugador: {},
    meterResultado: { type: Boolean },
    soloValidar: { type: Boolean },
    cambiarPairing: { type: Boolean }
  },
  emits: ["partidaActualizada"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const jugada = computed(() => partidaJugada(props.partida));
const puedeValidar = computed(
  () =>
    !jugada.value &&
    (props.partida.resultadoUsuario1 != null ||
      props.partida.resultadoUsuario2 != null)
);

// Con el sistema alemán, los puntos que reparte el resultado (siempre suman 20)
const aleman = useSistemaAleman();
const puntosAleman = computed(() => {
  const { resultadoUsuario1: r1, resultadoUsuario2: r2 } = props.partida;
  if (!aleman.value || r1 == null || r2 == null) return null;
  return calcularPuntosAleman(r1, r2);
});

// En verde el que pasa o, si no se dice, el que gana una partida ya jugada
const ganador = computed<1 | 2 | null>(() => {
  if (props.pasa) return props.pasa;
  const { resultadoUsuario1: r1, resultadoUsuario2: r2 } = props.partida;
  if (!jugada.value || r1 == null || r2 == null || r1 === r2) return null;
  return r1 > r2 ? 1 : 2;
});

// El lado de quien mira: el suyo si juega, es el compañero en Parejas o el capitán de ese equipo
const miLado = computed<1 | 2 | null>(() => {
  const p = props.partida;
  const id = props.idJugador;
  if (id == null) return null;
  if ([p.idUsuario1, p.idCompanero1, p.idCapitan1].includes(id)) return 1;
  if ([p.idUsuario2, p.idCompanero2, p.idCapitan2].includes(id)) return 2;
  return null;
});
// Lo que le toca al jugador, mientras no se haya jugado y el torneo siga abierto
const puedeActuar = computed(() => miLado.value !== null && !jugada.value && !cerrado.value);
const jugadorValida = computed(() => puedeActuar.value && props.soloValidar === true);
const jugadorMete = computed(
  () => puedeActuar.value && props.meterResultado === true && props.soloValidar !== true
);
// Algún botón para quien mira: si no, la tarjeta acaba en las validaciones
const hayBotones = computed(
  () =>
    puedeCambiarPairing.value ||
    jugadorValida.value ||
    jugadorMete.value ||
    (props.editable && !cerrado.value)
);
// En Parejas hay una partida por cruce: no se elige qué miembro juega contra cuál
const puedeCambiarPairing = computed(() => {
  const p = props.partida;
  const capitan = miLado.value === 1 ? p.idCapitan1 : miLado.value === 2 ? p.idCapitan2 : null;
  return (
    props.cambiarPairing === true &&
    puedeActuar.value &&
    capitan === props.idJugador &&
    p.idCompanero1 == null &&
    p.idCompanero2 == null
  );
});

// Los dos lados con lo que se pinta de cada uno
const lados = computed(() => {
  const p = props.partida;
  return ([1, 2] as const).map(lado => {
    const uno = lado === 1;
    const idCompanero = uno ? p.idCompanero1 : p.idCompanero2;
    const id = uno ? p.idUsuario1 : p.idUsuario2;
    return {
      lado,
      id,
      mio: props.idJugador != null && id === props.idJugador,
      // Torneos de más de una lista: todas las del jugador
      listas: uno ? p.listasJugador1 : p.listasJugador2,
      equipo: uno ? p.nombreEquipo1 : p.nombreEquipo2,
      nick: uno ? p.nick1 : p.nick2,
      ejercito: uno ? p.ejercitoUsuario1 : p.ejercitoUsuario2,
      companero: idCompanero
        ? {
            id: idCompanero,
            nick: (uno ? p.nickCompanero1 : p.nickCompanero2) ?? "",
            ejercito: uno ? p.ejercitoCompanero1 : p.ejercitoCompanero2,
          }
        : null,
      general: uno ? p.liderMuertoUsuario1 : p.liderMuertoUsuario2,
      elo: uno ? p.eloVariacionUsuario1 : p.eloVariacionUsuario2,
      validada: (uno ? p.partidaValidadaUsuario1 : p.partidaValidadaUsuario2) === true,
    };
  });
});

// Cada lado hacia su borde
const alineado = (l: { lado: 1 | 2 }) => (l.lado === 1 ? "text-left" : "text-right");

const fecha = computed(() =>
  props.partida.fechaPartida
    ? new Date(props.partida.fechaPartida).toLocaleDateString("es-ES")
    : ""
);

const textoElo = (variacion: number) =>
  `${variacion > 0 ? "+" : ""}${variacion} ELO`;
const colorElo = (variacion: number) =>
  variacion > 0 ? "text-success" : variacion < 0 ? "text-error" : "text-medium-emphasis";

// El aviso de éxito es el de la app: con un filtro, la tarjeta puede desaparecer al cambiar la partida
const { triggerToast } = useToast();
const cerrado = useTorneoCerrado();
const showEditar = ref(false);
const isCargando = ref(false);
const showError = ref(false);
const tituloError = ref<string | undefined>(undefined);
const mensajeError = ref("");

async function guardar(partidaEditada: PartidaTorneoDTO) {
  showEditar.value = false;
  isCargando.value = true;
  try {
    const actualizada = await updatePartidaTorneo(partidaEditada);
    emit("partidaActualizada", actualizada);
    triggerToast("success", "Resultado guardado.");
  } catch (error) {
    console.error(error);
    tituloError.value = undefined;
    mensajeError.value = mensajeDelBack(error, "No se ha podido guardar el resultado.");
    showError.value = true;
  } finally {
    isCargando.value = false;
  }
}

// Validar de un toque: el organizador da por buenos los datos que ya hay
const validando = ref(false);

async function validar() {
  validando.value = true;
  try {
    await updatePartidaTorneo({
      idPartidaTorneo: props.partida.idPartidaTorneo,
      partidaValidadaUsuario1: true,
      partidaValidadaUsuario2: true,
    });
    // La respuesta no trae los nicks: se cambia solo lo validado
    emit("partidaActualizada", {
      ...props.partida,
      partidaValidadaUsuario1: true,
      partidaValidadaUsuario2: true,
    });
    triggerToast("success", "Partida validada.");
  } catch (error) {
    console.error(error);
    tituloError.value = undefined;
    mensajeError.value = mensajeDelBack(error, "No se ha podido validar la partida.");
    showError.value = true;
  } finally {
    validando.value = false;
  }
}

// Lista con la que se jugó, o la actual si está pendiente
const lista = ref<{
  listaData: string;
  nick: string;
  ejercito?: string;
} | null>(null);

async function verLista(lado: 1 | 2) {
  isCargando.value = true;
  try {
    const response = await getListaPartidaAsync(props.partida.idPartidaTorneo, lado);
    lista.value = {
      listaData: response.data.listaData,
      nick: lado === 1 ? props.partida.nick1 : props.partida.nick2,
      ejercito: response.data.ejercito ?? undefined,
    };
  } catch (error) {
    tituloError.value = "Aviso";
    mensajeError.value = motivoSinLista(error);
    showError.value = true;
  } finally {
    isCargando.value = false;
  }
}

// Una lista concreta, en los torneos de más de una lista por jugador
async function verListaPorId(idLista: number | undefined, nick: string) {
  if (idLista == null) return;
  isCargando.value = true;
  try {
    const response = await getListaById(idLista);
    if (!response.data?.listaData) {
      tituloError.value = "Aviso";
      mensajeError.value = SIN_LISTA;
      showError.value = true;
      return;
    }
    lista.value = {
      listaData: response.data.listaData,
      nick,
      ejercito: response.data.ejercito ?? undefined,
    };
  } catch (error) {
    tituloError.value = "Aviso";
    mensajeError.value = motivoSinLista(error);
    showError.value = true;
  } finally {
    isCargando.value = false;
  }
}

// La del compañero en Parejas con una lista por jugador: la que tiene en el torneo
async function verListaCompanero(idUsuario: number, nick: string) {
  isCargando.value = true;
  try {
    const response = await getlistaTorneo({
      idTorneo: props.partida.idTorneo,
      idUsuario,
    });
    if (!response.data?.listaData) {
      tituloError.value = "Aviso";
      mensajeError.value = SIN_LISTA;
      showError.value = true;
      return;
    }
    lista.value = {
      listaData: response.data.listaData,
      nick,
      ejercito: response.data.ejercito ?? undefined,
    };
  } catch (error) {
    tituloError.value = "Aviso";
    mensajeError.value = motivoSinLista(error);
    showError.value = true;
  } finally {
    isCargando.value = false;
  }
}

// --- Lo que hace el jugador. Al guardarse se recarga la página: cambian la clasificación, el ELO y quién va ---

const router = useRouter();
const showResultadoJugador = ref(false);
const showValidarJugador = ref(false);
const showCambiarPairing = ref(false);

const verPerfil = (idUsuario: number | null | undefined) => {
  if (props.idJugador == null || idUsuario == null) return;
  router.push({ name: "detalle-jugador", params: { idUsuario } });
};

// Valida su lado: el del capitán o compañero es el de su equipo o pareja
const validaMiLado = (): Partial<UpdatePartidaTorneoDTO> =>
  miLado.value === 1 ? { partidaValidadaUsuario1: true } : { partidaValidadaUsuario2: true };

async function enviarJugador(body: UpdatePartidaTorneoDTO, porDefecto: string) {
  isCargando.value = true;
  try {
    await updatePartidaTorneo(body);
    window.location.reload();
  } catch (error) {
    console.error(error);
    // Sin recargar, para que se vea por qué no se ha guardado: por ejemplo, que el torneo ya está cerrado
    tituloError.value = undefined;
    mensajeError.value = mensajeDelBack(error, porDefecto);
    showError.value = true;
    isCargando.value = false;
  }
}

async function guardarJugador(editada: UpdatePartidaTorneoDTO) {
  showResultadoJugador.value = false;
  await enviarJugador(
    {
      idPartidaTorneo: props.partida.idPartidaTorneo,
      resultadoUsuario1: editada.resultadoUsuario1,
      resultadoUsuario2: editada.resultadoUsuario2,
      escenarioPartida: editada.escenarioPartida,
      liderMuertoUsuario1: editada.liderMuertoUsuario1,
      liderMuertoUsuario2: editada.liderMuertoUsuario2,
      ...validaMiLado(),
    },
    "No se ha podido guardar el resultado."
  );
}

async function validarJugador() {
  showValidarJugador.value = false;
  await enviarJugador(
    { idPartidaTorneo: props.partida.idPartidaTorneo, ...validaMiLado() },
    "No se ha podido validar la partida."
  );
}

async function cambiarPairing(payload: ActualizarPairingEquiposDTO) {
  showCambiarPairing.value = false;
  isCargando.value = true;
  try {
    await updatePairingTorneoAsync({
      idPartidaTorneo: props.partida.idPartidaTorneo,
      idUsuario1: payload.idJugador1,
      idUsuario2: payload.idJugador2,
    });
    window.location.reload();
  } catch (error) {
    console.error(error);
    tituloError.value = undefined;
    mensajeError.value = mensajeDelBack(error, "No se ha podido cambiar el emparejamiento.");
    showError.value = true;
    isCargando.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      variant: "outlined",
      class: "mb-2"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_text, { class: "pa-3" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.etiqueta), 1),
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.partida.escenarioPartida || (jugada.value ? "Sin escenario" : "Escenario por decidir")), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(fecha.value), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (lados.value.some(l => l.equipo))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(lados.value, (l, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `equipo${l.lado}`
                    }, [
                      (i === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-caption text-primary text-wrap", alineado(l)])
                      }, _toDisplayString(l.equipo), 3)
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lados.value, (l, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `nick${l.lado}`
                }, [
                  (i === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.partida.resultadoUsuario1 ?? "–") + " : " + _toDisplayString(_ctx.partida.resultadoUsuario2 ?? "–"), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["font-weight-bold text-wrap en-linea", [
              alineado(l),
              { 'text-success': ganador.value === l.lado, 'text-primary': ganador.value !== l.lado && l.mio },
            ]])
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass({ pulsable: _ctx.idJugador != null }),
                      onClick: ($event: any) => (verPerfil(l.id))
                    }, _toDisplayString(l.nick), 11, _hoisted_8)
                  ], 2)
                ], 64))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lados.value, (l, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `ejercito${l.lado}`
                }, [
                  (i === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (puntosAleman.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(puntosAleman.value.jugador1) + " : " + _toDisplayString(puntosAleman.value.jugador2), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["text-caption text-medium-emphasis text-wrap", alineado(l)])
                  }, [
                    (l.listas?.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(l.listas, (listaJugador, j) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: listaJugador.idLista ?? j
                          }, [
                            _createElementVNode("span", {
                              class: "enlace",
                              role: "button",
                              tabindex: "0",
                              onClick: ($event: any) => (verListaPorId(listaJugador.idLista, l.nick)),
                              onKeydown: _withKeys(($event: any) => (verListaPorId(listaJugador.idLista, l.nick)), ["enter"])
                            }, _toDisplayString(listaJugador.ejercito || "Ver lista"), 41, _hoisted_11)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "enlace",
                          role: "button",
                          tabindex: "0",
                          onClick: ($event: any) => (verLista(l.lado)),
                          onKeydown: _withKeys(($event: any) => (verLista(l.lado)), ["enter"])
                        }, _toDisplayString(l.ejercito || "Ver lista"), 41, _hoisted_12))
                  ], 2)
                ], 64))
              }), 128)),
              (lados.value.some(l => l.companero))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lados.value, (l, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `companero${l.lado}`
                      }, [
                        (i === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["font-weight-bold text-wrap mt-1", [
                alineado(l),
                {
                  'text-success': ganador.value === l.lado,
                  'text-primary': ganador.value !== l.lado && l.companero?.id === _ctx.idJugador,
                  pulsable: _ctx.idJugador != null,
                },
              ]]),
                          onClick: ($event: any) => (verPerfil(l.companero?.id))
                        }, _toDisplayString(l.companero?.nick), 11, _hoisted_14)
                      ], 64))
                    }), 128)),
                    (!_ctx.listaPorPareja)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(lados.value, (l, i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `ejercitoCompanero${l.lado}`
                          }, [
                            (i === 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-caption text-medium-emphasis text-wrap", alineado(l)])
                            }, [
                              (l.companero)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "enlace",
                                    role: "button",
                                    tabindex: "0",
                                    onClick: ($event: any) => (verListaCompanero(l.companero.id, l.companero.nick)),
                                    onKeydown: _withKeys(($event: any) => (verListaCompanero(l.companero.id, l.companero.nick)), ["enter"])
                                  }, _toDisplayString(l.companero.ejercito || "Ver lista"), 41, _hoisted_16))
                                : _createCommentVNode("", true)
                            ], 2)
                          ], 64))
                        }), 128))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (lados.value.some(l => l.general !== null))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(lados.value, (l, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `general${l.lado}`
                    }, [
                      (i === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-caption", [alineado(l), l.general ? 'text-success' : 'text-medium-emphasis']])
                      }, [
                        (l.general !== null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(l.general ? "Mató al general" : "No mató al general"), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true),
              (lados.value.some(l => l.elo != null))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(lados.value, (l, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: `elo${l.lado}`
                    }, [
                      (i === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(["text-caption", [alineado(l), l.elo != null ? colorElo(l.elo) : '']])
                      }, [
                        (l.elo != null)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(textoElo(l.elo)), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 2)
                    ], 64))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lados.value, (l, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `validada${l.lado}`
                }, [
                  (i === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        (jugada.value)
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              size: "small",
                              color: "success",
                              icon: "mdi-check-circle",
                              title: "Validada por los dos"
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(l.lado === 1 ? 'text-left' : 'text-right')
                  }, [
                    _createVNode(_component_v_chip, {
                      size: "x-small",
                      color: l.validada ? 'success' : 'warning'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(l.validada ? "Validada" : "Sin validar"), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ], 2)
                ], 64))
              }), 128))
            ]),
            (_ctx.$slots.chips || hayBotones.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _renderSlot(_ctx.$slots, "chips"),
                  _createElementVNode("div", _hoisted_22, [
                    (puedeCambiarPairing.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          size: "small",
                          variant: "tonal",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (showCambiarPairing.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Cambiar ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (jugadorValida.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          size: "small",
                          variant: "tonal",
                          color: "success",
                          "prepend-icon": "mdi-check-all",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (showValidarJugador.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Validar ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (jugadorMete.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 2,
                          size: "small",
                          variant: "tonal",
                          color: "primary",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (showResultadoJugador.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Meter resultado ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.editable && !_unref(cerrado) && puedeValidar.value)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 3,
                          size: "small",
                          variant: "tonal",
                          color: "success",
                          "prepend-icon": "mdi-check-all",
                          loading: validando.value,
                          onClick: validar
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Validar ")
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    (_ctx.editable && !_unref(cerrado))
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 4,
                          size: "small",
                          variant: "tonal",
                          color: "primary",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (showEditar.value = true))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Meter resultado ")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }),
    (showEditar.value)
      ? (_openBlock(), _createBlock(ModalEditarPartidaGestion, {
          key: 0,
          isVisible: showEditar.value,
          partida: _ctx.partida,
          onCerrar: _cache[4] || (_cache[4] = ($event: any) => (showEditar.value = false)),
          onConfirm: guardar
        }, null, 8, ["isVisible", "partida"]))
      : _createCommentVNode("", true),
    (showResultadoJugador.value && miLado.value)
      ? (_openBlock(), _createBlock(ModalEditarPartida, {
          key: 1,
          isVisible: showResultadoJugador.value,
          partida: _ctx.partida,
          idUsuario: miLado.value,
          onConfirmar: guardarJugador,
          onCerrar: _cache[5] || (_cache[5] = ($event: any) => (showResultadoJugador.value = false))
        }, null, 8, ["isVisible", "partida", "idUsuario"]))
      : _createCommentVNode("", true),
    (showValidarJugador.value)
      ? (_openBlock(), _createBlock(ModalValidarPartida, {
          key: 2,
          isVisible: showValidarJugador.value,
          idPartidaTorneo: _ctx.partida.idPartidaTorneo,
          resumen: `${_ctx.partida.nick1} ${_ctx.partida.resultadoUsuario1 ?? '–'} - ${_ctx.partida.resultadoUsuario2 ?? '–'} ${_ctx.partida.nick2}`,
          onConfirmar: validarJugador,
          onCerrar: _cache[6] || (_cache[6] = ($event: any) => (showValidarJugador.value = false))
        }, null, 8, ["isVisible", "idPartidaTorneo", "resumen"]))
      : _createCommentVNode("", true),
    (showCambiarPairing.value && _ctx.partida.idEquipo1 && _ctx.partida.idEquipo2)
      ? (_openBlock(), _createBlock(ModalCambiarPairingEquipo, {
          key: 3,
          isVisible: showCambiarPairing.value,
          idEquipo1: _ctx.partida.idEquipo1,
          idEquipo2: _ctx.partida.idEquipo2,
          nombreEquipo1: _ctx.partida.nombreEquipo1 ?? '',
          nombreEquipo2: _ctx.partida.nombreEquipo2 ?? '',
          onActualizar: cambiarPairing,
          onCerrar: _cache[7] || (_cache[7] = ($event: any) => (showCambiarPairing.value = false))
        }, null, 8, ["isVisible", "idEquipo1", "idEquipo2", "nombreEquipo1", "nombreEquipo2"]))
      : _createCommentVNode("", true),
    (lista.value)
      ? (_openBlock(), _createBlock(ModalListaResultadoTorneo, {
          key: 4,
          listaData: lista.value.listaData,
          nickJugador: lista.value.nick,
          ejercito: lista.value.ejercito,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (lista.value = null))
        }, null, 8, ["listaData", "nickJugador", "ejercito"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: isCargando.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isCargando).value = $event)),
      persistent: "",
      width: "200"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "pa-6 d-flex justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "60"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (showError.value)
      ? (_openBlock(), _createBlock(ModalError, {
          key: 5,
          isVisible: showError.value,
          titulo: tituloError.value,
          message: mensajeError.value,
          "onUpdate:isVisible": _cache[10] || (_cache[10] = ($event: any) => (showError.value = $event))
        }, null, 8, ["isVisible", "titulo", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})